var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedularHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 5.33334H6.16667C5.24619 5.33334 4.5 6.07954 4.5 7.00001V18.6667C4.5 19.5872 5.24619 20.3333 6.16667 20.3333H17.8333C18.7538 20.3333 19.5 19.5872 19.5 18.6667V7.00001C19.5 6.07954 18.7538 5.33334 17.8333 5.33334Z",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 3.66666V6.99999",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 3.66666V6.99999",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.3333H19.5",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedularHeaderIcon);
export default __webpack_public_path__ + "static/media/schedular_header_icon.e4ea35cb77fb5e65aebf460ae50785f4.svg";
export { ForwardRef as ReactComponent };